import { RootState } from 'src/store/store';
import { OverlaySliceStateType } from 'src/store/overlay/slice';

export const overlaySelector = ({ overlay }: RootState): OverlaySliceStateType => overlay;
